import { Component, EventEmitter, Input, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { GridApiService } from "src/app/data-grid/grid-api.service";
import { SkuDetail, SkuListItem } from "src/app/models/priceyard.model";
import { SkuMappingEditComponent } from "src/app/modules/detail/presentational/sku-mapping-edit/sku-mapping-edit.component";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { ConfirmDialogComponent } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { HeaderService } from 'src/app/components/header/header.service';
@Component({
  selector: "app-shipyard-panel",
  templateUrl: "./shipyard-panel.component.html",
  styleUrls: ["./shipyard-panel.component.scss"],
})
export class ShipyardPanelComponent implements OnInit,OnDestroy {
  _selectedSku: any;
  get selectedSku() {
    return this._selectedSku;
  }
  @Input() set selectedSku(value) {
    this._selectedSku = value;
    this.shipmentType.setValue(this.selectedSku.fbaType);
    this.gettingSkuMapping();
  }
  skus: SkuListItem[]=[];
  shipmentType = new FormControl("");
  mappings;
  editEvent: EventEmitter<any> = new EventEmitter();
  isPlanyard: any;
  private destroy$ = new Subject<void>();
  fbaTypes = this.shipyardService.getAllShipmentTypes();
  isWalmartAccount:boolean;

  constructor(
    public gridActionsService: GridActionsService,
    private dialog: MatDialog,
    private planyardService: PlanyardService,
    private gridApiService: GridApiService,
    private shipyardService: ShipyardService,
    private headerService:HeaderService
  ) {
    this.headerService.accountSelectedType
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        if (e) {
          this.isWalmartAccount = e[0] ==='Walmart';         
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.isPlanyard = JSON.parse(
      localStorage.getItem(StorageKeyEnum.User)
    ).isPlanYard;
    this.gridApiService.selectedRows$
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedRows) => {
        this.skus = selectedRows;
      });    
  }

  updateFbaType() {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Update FBA Type",
          message: "Are you sure you want to update FBA Type?",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res === "Confirm") {
          this.gridActionsService.updateFbaType([this.skus], this.shipmentType);
        } else {
          this.shipmentType.setValue(this.selectedSku.fbaType);
        }
      });
  }

  gettingSkuMapping() {
    this.planyardService
      .GetSkuMappings(this.selectedSku.accountSkuId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => (this.mappings = e));
  }

  editMapping() {
    this.editEvent.emit({
      component: SkuMappingEditComponent,
      title: "Edit Mapping",
      id: this.selectedSku.sku,
      mappings: this.mappings,
    });
  }
}
